import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the structure of your context data
interface ReportContextType {
  type: string;
  setType: React.Dispatch<React.SetStateAction<string>>;
  itemType: string;
  setItemType: React.Dispatch<React.SetStateAction<string>>;
  lat: number;
  setLat: React.Dispatch<React.SetStateAction<number>>;
  lng: number;
  setLng: React.Dispatch<React.SetStateAction<number>>;
  bid: string;
  setBid: React.Dispatch<React.SetStateAction<string>>;
  geom: Array<[number, number]>;
  setGeom: React.Dispatch<React.SetStateAction<Array<[number, number]>>>;
  zoning: string;
  setZoning: React.Dispatch<React.SetStateAction<string>>;
  exchangeItemCategory: string;
  setExchangeItemCategory: React.Dispatch<React.SetStateAction<string>>;
  iidx: string;
  setIidx: React.Dispatch<React.SetStateAction<string>>;
  regionAccess: boolean;
  setRegionAccess: React.Dispatch<React.SetStateAction<boolean>>;
  quotaAccess: boolean;
  setQuotaAccess: React.Dispatch<React.SetStateAction<boolean>>;
}

// Create the context with a default value
const ReportContext = createContext<ReportContextType | undefined>(undefined);

export const ReportProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [iidx, setIidx] = useState('');
  const [type, setType] = useState('a');
  const [itemType, setItemType] = useState('L');
  const [lat, setLat] = useState(36.6157221183666);
  const [lng, setLng] = useState(127.449105266211);
  const [bid, setBid] = useState('');
  const [geom, setGeom] = useState<Array<[number, number]>>([]);
  const [zoning, setZoning] = useState('');
  const [exchangeItemCategory, setExchangeItemCategory] = useState('');
  const [regionAccess, setRegionAccess] = useState(false); // 권한 확인
  const [quotaAccess, setQuotaAccess] = useState(false); // 이용권 소진 여부

  return (
    <ReportContext.Provider
      value={{
        exchangeItemCategory,
        setExchangeItemCategory,
        type,
        setType,
        itemType,
        setItemType,
        lat,
        setLat,
        lng,
        setLng,
        bid,
        setBid,
        geom,
        setGeom,
        zoning,
        setZoning,
        iidx,
        setIidx,
        regionAccess,
        setRegionAccess,
        quotaAccess,
        setQuotaAccess,
      }}
    >
      {children}
    </ReportContext.Provider>
  );
};

// Custom hook to use the context
export const useReportContext = () => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error('useReportContext must be used within a ReportProvider');
  }
  return context;
};
